import React from "react";

// Last-resort guard: a render crash shows a friendly reload screen instead of a
// blank white page (and logs the error for debugging / future Sentry).
export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Render crash:", error, info?.componentStack);
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, fontFamily: "system-ui, sans-serif", textAlign: "center" }}>
        <div>
          <p style={{ fontSize: 40, margin: 0 }}>☕</p>
          <h1 style={{ fontSize: 20, margin: "12px 0 6px" }}>Oups — un pépin d'affichage.</h1>
          <p style={{ color: "#64748b", margin: "0 0 16px" }}>Something went wrong. / Une erreur est survenue.</p>
          <button onClick={() => window.location.reload()}
            style={{ background: "#ea580c", color: "#fff", border: 0, borderRadius: 8, padding: "10px 20px", fontSize: 15, cursor: "pointer" }}>
            Recharger la page
          </button>
        </div>
      </div>
    );
  }
}
